import internetDCI from "public/network-services/icons/internet-dci.png";
import { SimpleList } from "@/components/list";

const DIA_POINTS = [
  "Symmetrical bandwidth options ranging from 100 Mbps to 100 Gbps.",
  "99.99% uptime SLA for consistent, high-speed connectivity.",
  "Direct peering with major ISPs and cloud providers for optimal performance.",
];

const CN_POINTS = [
  "Multi-site connectivity across geographically dispersed data centers.",
  "Low-latency fiber interconnects for fast data replication and workload distribution.",
  "Secure, high-bandwidth links for private cloud and hybrid cloud integrations.",
];

const HAR_POINTS = [
  "Self-healing network architecture minimizes downtime.",
  "Automatic failover mechanisms ensure uninterrupted operations.",
  "Diverse fiber paths eliminate single points of failure.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of Internet & DCI Services",
  list: [
    {
      content: <SimpleList points={DIA_POINTS} />,
      image: internetDCI,
      title: "Dedicated Internet Access (DIA)",
    },
    {
      content: <SimpleList points={CN_POINTS} />,
      image: internetDCI,
      title: "Carrier-Neutral Data Center Interconnect",
    },
    {
      content: <SimpleList points={HAR_POINTS} />,
      image: internetDCI,
      title: "High Availability & Redundancy",
    },
  ],
};
